var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHouse = function SvgHouse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.51 9.722l-7.501-6.82c-.276-.251-.636-.391-1.01-.391-.373 0-.733.14-1.008.392l-7.5 6.819c-.154.14-.278.312-.362.503-.085.191-.129.398-.129.607v8.634c-.004.377.13.742.376 1.027.14.16.314.288.507.375.194.088.405.132.617.132h4.497c.199 0 .39-.08.53-.22s.22-.331.22-.53v-4.5c0-.2.079-.39.22-.531.14-.14.33-.22.53-.22h3c.199 0 .39.08.53.22s.22.331.22.53v4.5c0 .2.079.39.22.531.14.14.33.22.53.22h4.505c.247.003.49-.057.707-.174.239-.13.439-.32.578-.554.14-.233.213-.5.213-.772v-8.668c0-.21-.044-.416-.128-.607-.085-.191-.208-.362-.363-.503z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHouse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/House.63946bd3.svg";
export { ForwardRef as ReactComponent };